"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlImporterFontUtils = void 0;
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var HtmlImporterFontUtils = (function () {
    function HtmlImporterFontUtils() {
    }
    HtmlImporterFontUtils.getFontSize = function (font, parentFont) {
        var fontSize = HtmlImporterFontUtils.getFontSizeCore(font);
        if (fontSize !== null)
            return fontSize;
        var parentFontSize = HtmlImporterFontUtils.getFontSizeCore(parentFont);
        var currentFontSize = parentFontSize !== null ? parentFontSize : 12;
        if (font.indexOf("em") > 0)
            return parseInt(font) * currentFontSize;
        if (font.indexOf("%") > 0)
            return parseInt(font) * currentFontSize / 100;
        return null;
    };
    HtmlImporterFontUtils.getFontSizeCore = function (font) {
        if (!font)
            return null;
        if (font.indexOf("px") > 0)
            return unit_converter_1.UnitConverter.pixelsToPoints(parseInt(font));
        if (font.indexOf("pt") > 0)
            return parseInt(font);
        return null;
    };
    return HtmlImporterFontUtils;
}());
exports.HtmlImporterFontUtils = HtmlImporterFontUtils;
